export const iconFontAwesomeDesignWandMagic = (
	<i className="fa-solid fa-wand-magic"></i>
);
